import React, { useState } from 'react';

const pendingOrders = [
  {id:'ORD003',customer:'Murugan',phone:'9012345678',address:'45, Gandhi Nagar, ஈரோடு',items:['Amlodipine 5mg x1'],total:38,distance:'1.2 km',vendor:'Sri Murugan Pharmacy',vendorAddr:'Perundurai Road'},
  {id:'ORD006',customer:'Anitha',phone:'9876501234',address:'12, Nehru Street, ஈரோடு',items:['Dolo 650 x2','Vitamin D3 x1'],total:180,distance:'2.5 km',vendor:'Lakshmi Medical',vendorAddr:'Sathy Road'},
];

const completedOrders = [
  {id:'ORD001',customer:'Rajesh Kumar',total:105,distance:'1.8 km',time:'2:45 PM',earning:53},
  {id:'ORD002',customer:'Priya Devi',total:170,distance:'3.2 km',time:'3:10 PM',earning:85},
  {id:'ORD004',customer:'Kavitha',total:140,distance:'2.1 km',time:'3:30 PM',earning:70},
];

function DriverApp() {
  const [screen, setScreen] = useState('login');
  const [tab, setTab] = useState('home');
  const [phone, setPhone] = useState('');
  const [online, setOnline] = useState(true);
  const [activeOrder, setActiveOrder] = useState(null);
  const [orderStep, setOrderStep] = useState(0);

  const hdr = {background:'linear-gradient(135deg,#1b5e20,#2e7d32)',padding:'12px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'};
  const btn = (bg='linear-gradient(135deg,#1b5e20,#2e7d32)') => ({background:bg,color:'white',border:'none',borderRadius:'8px',padding:'8px 14px',cursor:'pointer',fontSize:'13px',fontWeight:'bold'});
  const navBtn = (t) => ({flex:1,padding:'8px 0',border:'none',background:tab===t?'linear-gradient(135deg,#1b5e20,#2e7d32)':'white',color:tab===t?'white':'#666',cursor:'pointer',fontSize:'9px',fontWeight:tab===t?'bold':'normal'});

  const todayEarning = completedOrders.reduce((a,o)=>a+o.earning,0);
  const steps = ['📦 மருந்தகத்திலிருந்து எடுக்கவும்','🛵 டெலிவரி வழியில்','🏠 வாடிக்கையாளரிடம் சேர்ப்பிக்கவும்','✅ டெலிவரி முடிந்தது'];

  if(screen==='login') return (
    <div style={{minHeight:'100vh',background:'#e8f5e9',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'white',padding:'40px',borderRadius:'16px',width:'340px',boxShadow:'0 4px 20px rgba(0,0,0,0.1)'}}>
        <div style={{textAlign:'center',marginBottom:'24px'}}>
          <div style={{fontSize:'60px'}}>🛵</div>
          <h2 style={{color:'#1b5e20',margin:'8px 0'}}>Driver Login</h2>
          <p style={{color:'#666',fontSize:'13px'}}>Sashtimedix Delivery Partner</p>
        </div>
        <input type="tel" placeholder="📱 தொலைபேசி எண்" value={phone} onChange={e=>setPhone(e.target.value)}
          style={{width:'100%',padding:'12px',borderRadius:'8px',border:'2px solid #1b5e20',boxSizing:'border-box',marginBottom:'10px',fontSize:'15px'}}/>
        <input type="password" placeholder="🔒 கடவுச்சொல்"
          style={{width:'100%',padding:'12px',borderRadius:'8px',border:'2px solid #1b5e20',boxSizing:'border-box',marginBottom:'16px',fontSize:'15px'}}/>
        <button onClick={()=>setScreen('app')} style={{...btn(),width:'100%',padding:'14px',fontSize:'16px'}}>
          உள்நுழைய →
        </button>
        <div style={{background:'#e8f5e9',borderRadius:'10px',padding:'12px',marginTop:'16px',textAlign:'center'}}>
          <p style={{color:'#2e7d32',fontSize:'13px',margin:0}}>💰 ஒவ்வொரு டெலிவரிக்கும் ₹50 சம்பளம்</p>
        </div>
      </div>
    </div>
  );

  if(activeOrder) return (
    <div style={{fontFamily:'sans-serif',maxWidth:'600px',margin:'0 auto',minHeight:'100vh',background:'#f1f8e9'}}>
      <div style={hdr}>
        <h2 style={{color:'white',margin:0,fontSize:'18px'}}>🛵 டெலிவரி நடக்கிறது</h2>
        <span style={{color:'white',fontSize:'13px'}}>#{activeOrder.id}</span>
      </div>
      <div style={{padding:'16px'}}>
        <div style={{background:'white',borderRadius:'12px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h3 style={{color:'#1b5e20',margin:'0 0 14px'}}>📍 டெலிவரி படிகள்</h3>
          {steps.map((step,i)=>(
            <div key={i} style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'14px'}}>
              <div style={{width:'36px',height:'36px',borderRadius:'50%',background:i<orderStep?'#2e7d32':i===orderStep?'#1b5e20':'#e0e0e0',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',flexShrink:0,color:'white',fontWeight:'bold'}}>
                {i<orderStep?'✓':i+1}
              </div>
              <div style={{flex:1,color:i<=orderStep?'#333':'#999',fontWeight:i===orderStep?'bold':'normal'}}>{step}</div>
            </div>
          ))}
        </div>

        <div style={{background:'white',borderRadius:'12px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <h3 style={{color:'#1b5e20',margin:'0 0 12px'}}>{orderStep===0?'🏪 மருந்தகம்':'🏠 வாடிக்கையாளர்'}</h3>
          <div style={{marginBottom:'6px',fontWeight:'bold'}}>{orderStep===0?activeOrder.vendor:activeOrder.customer}</div>
          <div style={{color:'#666',fontSize:'13px',marginBottom:'6px'}}>📍 {orderStep===0?activeOrder.vendorAddr:activeOrder.address}</div>
          <div style={{color:'#666',fontSize:'13px',marginBottom:'12px'}}>📱 {activeOrder.phone}</div>
          <div style={{display:'flex',gap:'8px'}}>
            <a href={`tel:${activeOrder.phone}`} style={{...btn(),flex:1,textDecoration:'none',textAlign:'center',padding:'10px'}}>📞 அழைக்க</a>
            <button style={{...btn('linear-gradient(135deg,#1565c0,#0d47a1)'),flex:1,padding:'10px'}}>🗺️ Navigate</button>
          </div>
        </div>

        <div style={{background:'white',borderRadius:'12px',padding:'16px',marginBottom:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
          <div style={{fontSize:'13px',color:'#666',marginBottom:'4px'}}>💊 {activeOrder.items.join(', ')}</div>
          <div style={{fontWeight:'bold',color:'#2e7d32',fontSize:'16px'}}>மொத்தம்: ₹{activeOrder.total}</div>
        </div>

        {orderStep<3?(
          <button onClick={()=>setOrderStep(s=>s+1)} style={{...btn(),width:'100%',padding:'16px',fontSize:'16px'}}>
            {orderStep===0?'📦 எடுத்தேன் — கிளம்புகிறேன்':orderStep===1?'🏠 வாடிக்கையாளரிடம் சேர்ந்தேன்':'✅ டெலிவரி முடித்தேன்'}
          </button>
        ):(
          <button onClick={()=>{setActiveOrder(null);setOrderStep(0);setTab('home');}} style={{...btn('linear-gradient(135deg,#2e7d32,#1b5e20)'),width:'100%',padding:'16px',fontSize:'16px'}}>
            🎉 ₹50 சம்பாதித்தேன்! முகப்பு →
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div style={{fontFamily:'sans-serif',maxWidth:'600px',margin:'0 auto',minHeight:'100vh',background:'#f1f8e9',paddingBottom:'60px'}}>

      {/* HEADER */}
      <div style={hdr}>
        <div>
          <div style={{color:'white',fontWeight:'bold',fontSize:'16px'}}>🛵 Karthi</div>
          <div style={{color:'rgba(255,255,255,0.8)',fontSize:'12px'}}>Sashtimedix Driver</div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <span style={{color:'white',fontSize:'12px'}}>{online?'🟢 Online':'🔴 Offline'}</span>
          <div onClick={()=>setOnline(!online)}
            style={{width:'44px',height:'24px',borderRadius:'12px',background:online?'#4caf50':'#9e9e9e',cursor:'pointer',position:'relative'}}>
            <div style={{width:'20px',height:'20px',borderRadius:'50%',background:'white',position:'absolute',top:'2px',left:online?'22px':'2px',transition:'left 0.3s'}}></div>
          </div>
        </div>
      </div>

      {/* HOME TAB */}
      {tab==='home'&&(
        <div style={{padding:'16px'}}>
          {/* TODAY STATS */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'10px',marginBottom:'16px'}}>
            {[['💰',`₹${todayEarning}`,'இன்று சம்பளம்'],['📦',completedOrders.length,'டெலிவரி'],['⭐','4.9','Rating']].map(([icon,val,label],i)=>(
              <div key={i} style={{background:'white',borderRadius:'12px',padding:'12px',textAlign:'center',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
                <div style={{fontSize:'22px'}}>{icon}</div>
                <div style={{fontWeight:'bold',color:'#1b5e20',fontSize:'16px'}}>{val}</div>
                <div style={{color:'#666',fontSize:'10px'}}>{label}</div>
              </div>
            ))}
          </div>

          {/* NEW ORDER REQUESTS */}
          {online&&(
            <>
              <h3 style={{color:'#1b5e20',margin:'0 0 12px'}}>🔔 புதிய ஆர்டர் கோரிக்கைகள்</h3>
              {pendingOrders.map(order=>(
                <div key={order.id} style={{background:'white',borderRadius:'12px',padding:'16px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',border:'2px solid #a5d6a7'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
                    <span style={{fontWeight:'bold',color:'#1b5e20'}}>#{order.id}</span>
                    <span style={{background:'#e8f5e9',color:'#2e7d32',padding:'3px 10px',borderRadius:'20px',fontSize:'12px',fontWeight:'bold'}}>📍 {order.distance}</span>
                  </div>
                  <div style={{marginBottom:'4px'}}>🏪 <strong>{order.vendor}</strong></div>
                  <div style={{color:'#666',fontSize:'13px',marginBottom:'4px'}}>📍 {order.vendorAddr}</div>
                  <div style={{marginBottom:'4px'}}>👤 <strong>{order.customer}</strong></div>
                  <div style={{color:'#666',fontSize:'13px',marginBottom:'8px'}}>📍 {order.address}</div>
                  <div style={{color:'#666',fontSize:'12px',marginBottom:'10px'}}>💊 {order.items.join(', ')}</div>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'10px'}}>
                    <span style={{fontWeight:'bold',color:'#2e7d32',fontSize:'16px'}}>₹{order.total}</span>
                    <span style={{color:'#1b5e20',fontWeight:'bold'}}>💰 ₹50 சம்பளம்</span>
                  </div>
                  <div style={{display:'flex',gap:'8px'}}>
                    <button onClick={()=>{setActiveOrder(order);setOrderStep(0);}} style={{...btn(),flex:2,padding:'12px',fontSize:'14px'}}>✅ ஏற்கிறேன்</button>
                    <button style={{...btn('linear-gradient(135deg,#c62828,#b71c1c)'),flex:1,padding:'12px',fontSize:'14px'}}>❌ மறுக்கிறேன்</button>
                  </div>
                </div>
              ))}
            </>
          )}

          {!online&&(
            <div style={{background:'white',borderRadius:'12px',padding:'40px',textAlign:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
              <div style={{fontSize:'60px',marginBottom:'12px'}}>😴</div>
              <h3 style={{color:'#666'}}>நீங்கள் Offline-ல் உள்ளீர்கள்</h3>
              <p style={{color:'#999',fontSize:'14px'}}>ஆர்டர் பெற Online ஆகுங்கள்</p>
              <button onClick={()=>setOnline(true)} style={{...btn(),padding:'12px 24px'}}>🟢 Online ஆகு</button>
            </div>
          )}
        </div>
      )}

      {/* EARNINGS TAB */}
      {tab==='earnings'&&(
        <div style={{padding:'16px'}}>
          <h2 style={{color:'#1b5e20',margin:'0 0 16px'}}>💰 வருவாய்</h2>
          <div style={{background:'linear-gradient(135deg,#1b5e20,#2e7d32)',borderRadius:'12px',padding:'20px',marginBottom:'16px',color:'white',textAlign:'center'}}>
            <div style={{fontSize:'13px',opacity:0.8,marginBottom:'4px'}}>இந்த மாதம் மொத்த சம்பளம்</div>
            <div style={{fontSize:'36px',fontWeight:'bold',marginBottom:'4px'}}>₹8,450</div>
            <div style={{fontSize:'13px',opacity:0.8}}>169 டெலிவரி | ⭐ 4.9</div>
          </div>
          <h3 style={{color:'#1b5e20',margin:'0 0 12px'}}>இன்றைய டெலிவரிகள்</h3>
          {completedOrders.map(order=>(
            <div key={order.id} style={{background:'white',borderRadius:'12px',padding:'14px',marginBottom:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div>
                  <div style={{fontWeight:'bold',color:'#1b5e20'}}>#{order.id}</div>
                  <div style={{color:'#666',fontSize:'13px'}}>👤 {order.customer}</div>
                  <div style={{color:'#666',fontSize:'12px'}}>📍 {order.distance} | ⏰ {order.time}</div>
                </div>
                <div style={{textAlign:'right'}}>
                  <div style={{fontWeight:'bold',color:'#2e7d32',fontSize:'18px'}}>₹{order.earning}</div>
                  <div style={{color:'#999',fontSize:'12px'}}>சம்பளம்</div>
                </div>
              </div>
            </div>
          ))}
          <div style={{background:'#e8f5e9',borderRadius:'12px',padding:'14px',textAlign:'center',border:'1px solid #a5d6a7'}}>
            <div style={{fontWeight:'bold',color:'#1b5e20',fontSize:'18px'}}>இன்று: ₹{todayEarning}</div>
            <div style={{color:'#666',fontSize:'13px'}}>{completedOrders.length} டெலிவரி முடிந்தது</div>
          </div>
        </div>
      )}

      {/* PROFILE TAB */}
      {tab==='profile'&&(
        <div style={{padding:'16px'}}>
          <div style={{background:'linear-gradient(135deg,#1b5e20,#2e7d32)',borderRadius:'12px',padding:'20px',marginBottom:'16px',color:'white',textAlign:'center'}}>
            <div style={{fontSize:'60px',marginBottom:'8px'}}>🛵</div>
            <h2 style={{margin:'0 0 4px'}}>Karthi</h2>
            <p style={{margin:'0 0 4px',opacity:0.9}}>+91 98765 12345</p>
            <div style={{display:'flex',justifyContent:'center',gap:'16px',marginTop:'10px'}}>
              <div style={{textAlign:'center'}}>
                <div style={{fontWeight:'bold',fontSize:'18px'}}>169</div>
                <div style={{fontSize:'11px',opacity:0.8}}>டெலிவரி</div>
              </div>
              <div style={{textAlign:'center'}}>
                <div style={{fontWeight:'bold',fontSize:'18px'}}>4.9⭐</div>
                <div style={{fontSize:'11px',opacity:0.8}}>Rating</div>
              </div>
              <div style={{textAlign:'center'}}>
                <div style={{fontWeight:'bold',fontSize:'18px'}}>₹8,450</div>
                <div style={{fontSize:'11px',opacity:0.8}}>இம்மாதம்</div>
              </div>
            </div>
          </div>
          <div style={{background:'white',borderRadius:'12px',padding:'4px',marginBottom:'12px',boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
            {[['🚗','வாகனம்','Bike — TN 33 AB 1234'],
              ['🪪','License','TN-DL-2020-12345'],
              ['📅','சேர்ந்த நாள்','January 2024'],
              ['📍','பகுதி','ஈரோடு District'],
              ['💳','Bank','SBI — ****5678'],
            ].map(([icon,label,val],i)=>(
              <div key={i} style={{display:'flex',alignItems:'center',gap:'14px',padding:'14px 16px',borderBottom:i<4?'1px solid #f5f5f5':'none'}}>
                <span style={{fontSize:'20px'}}>{icon}</span>
                <div style={{flex:1}}>
                  <div style={{color:'#666',fontSize:'11px'}}>{label}</div>
                  <div style={{color:'#333',fontWeight:'500'}}>{val}</div>
                </div>
              </div>
            ))}
          </div>
          <button onClick={()=>setScreen('login')} style={{...btn('linear-gradient(135deg,#c62828,#b71c1c)'),width:'100%',padding:'14px',fontSize:'15px'}}>
            🚪 வெளியேறு
          </button>
        </div>
      )}

      {/* BOTTOM NAVIGATION */}
      <div style={{position:'fixed',bottom:0,left:'50%',transform:'translateX(-50%)',width:'100%',maxWidth:'600px',display:'flex',background:'white',boxShadow:'0 -2px 10px rgba(0,0,0,0.1)',zIndex:100}}>
        {[['🏠','முகப்பு','home'],['💰','வருவாய்','earnings'],['👤','சுயவிவரம்','profile']].map(([icon,label,t])=>(
          <button key={t} onClick={()=>setTab(t)} style={navBtn(t)}>
            <div style={{fontSize:'22px'}}>{icon}</div>
            <div>{label}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
export default DriverApp;